import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AddBanner.css";
import { createBanner } from "../../../services/Banner/Banner.service";
import { toast } from "react-toastify";

const AddBanner: React.FC = () => {
  const [bannerName, setBannerName] = useState("");
  const [bannerImage, setBannerImage] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setBannerImage(file);

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result as string);
      reader.readAsDataURL(file);
    }
  };

  const openFilePicker = () => {
    fileInputRef.current?.click();
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!bannerName.trim()) {
      toast.error("Banner name is required");
      return;
    }

    if (!bannerImage) {
      toast.warning("Please upload banner image");
      return;
    }

    try {
      await createBanner(bannerName, bannerImage);
      toast.success("Banner created successfully 🎉");
      navigate("/banner/list");
    } catch (error) {
      console.error("Error creating:", error);
      toast.error("Failed to create banner. Try again!");
    }
  };

  return (
    <div className="banner-overlay">
      <div className="add-category-container">
        <button
          type="button"
          className="close-btn"
          aria-label="Close"
          onClick={() => navigate("/banner/list")}
        >
          &times;
        </button>
        <h2>Add Banner</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Enter Banner Name"
            value={bannerName}
            onChange={(e) => setBannerName(e.target.value)}
          />

          <div className="image-upload-box" onClick={openFilePicker}>
            {preview ? (
              <img src={preview} alt="Preview" className="preview-image" />
            ) : (
              <span>Click to upload image</span>
            )}
          </div>

          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            style={{ display: "none" }}
          />

          <button type="submit">Save</button>
        </form>
      </div>
    </div>
  );
};

export default AddBanner;
